import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../coverpath-common/angular/services/modal/modal.service';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ModalType } from '../../../../../../../coverpath-common/js/interfaces/CoverpathTypes';
import { AbstractSplitModalComponent } from '../abstract-split-modal/abstract-split-modal.component';

@Component({
  selector: 'bene-widgete-split',
  moduleId: module.id,
  templateUrl: './bene-widget-split.component.html',
})
export class BeneWidgetComponentSplit extends AbstractSplitModalComponent {
  policyType: string;

  constructor(amorphicService: AmorphicService, modalService: ModalService) {
    super(amorphicService, modalService);
  }

  ngOnInit(): void {}

  submitJointDecision() {
    this.modalService.deactivate();
    const application = this.amorphicService.controller.customer.application;
    // checking to see where the term policy is stored is not necessary because
    // this component is only called in a joint app scenario
    let policyNumber;
    if (this.policyType === 'Term') {
      policyNumber = application.secondaryPolicy.policyNumber;
    } else if (this.policyType === 'Both') {
      return; // not yet implemented
    } else {
      policyNumber = application.primaryPolicy.policyNumber;
    }
    this.modalService.activate({ type: ModalType.beneWidget, policyType: this.policyType });
  }

  setSelection(policyType: string) {
    this.policyType = policyType;
  }

  valueSelected() {
    return !!this.policyType;
  }

  exit() {
    this.modalService.deactivate();
  }
}
